(() => {
  if (window.ffBrandReady) return;
  window.ffBrandReady = true;
  if (!customElements.get('ff-cart-consent')) {
    customElements.define('ff-cart-consent', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (!this.isConnected || this.bound) return;
          this.input = this.querySelector('input[type="checkbox"]');
          this.target = document.getElementById(this.input?.dataset.target?.replace(/^#/, ''));
          if (!this.input || !this.target) return;
          this.bound = true;
          this.form = this.target.form;
          this.onChange = () => { this.target.disabled = !this.input.checked; };
          this.onCheckout = event => {
            if (this.input.checked) return;
            event.preventDefault();
            event.stopImmediatePropagation();
            this.input.focus();
            this.input.reportValidity();
          };
          this.input.addEventListener('change', this.onChange);
          this.target.addEventListener('click', this.onCheckout, true);
          this.form?.addEventListener('submit', this.onCheckout, true);
          this.observer = new MutationObserver(() => {
            if (!this.input.checked && !this.target.disabled) this.target.disabled = true;
          });
          this.observer.observe(this.target, {attributes:true,attributeFilter:['disabled']});
          this.onChange();
        });
      }
      disconnectedCallback() {
        this.input?.removeEventListener('change', this.onChange);
        this.target?.removeEventListener('click', this.onCheckout, true);
        this.form?.removeEventListener('submit', this.onCheckout, true);
        this.observer?.disconnect();
        this.bound = false;
      }
    });
  }
  window.ffSetWishlistVariant = (card, variantId) => {
    const old = card.querySelector('.gw-add-to-wishlist-product-card-placeholder');
    if (!old || old.dataset.gwVariantId === String(variantId)) return;
    const fresh = document.createElement('div');
    fresh.className = old.className;
    fresh.dataset.gwProductId = old.dataset.gwProductId;
    fresh.dataset.gwVariantId = String(variantId);
    fresh.dataset.gwExactVariantId = 'true';
    fresh.dataset.gwWidgetPosition = 'right';
    fresh.style.display = 'block';
    old.replaceWith(fresh);
  };
  if (!customElements.get('ff-price-filter')) {
    customElements.define('ff-price-filter', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        const ranges = [...this.querySelectorAll('[data-price-slider]')];
        const fields = [...this.querySelectorAll('[data-price-value]')];
        const track = this.querySelector('.ff-price-track');
        const limit = Number(ranges[1].max);
        const sync = (source, index) => {
          let low = Number(fields[0].value || 0);
          let high = Number(fields[1].value || limit);
          if (source === 'range') {
            low = Number(ranges[0].value);
            high = Number(ranges[1].value);
          }
          if (source === 'input' && (fields.some(field => field.value === '' || !Number.isFinite(Number(field.value))) || low < 0 || high > limit || low > high)) return;
          low = Math.max(0, Math.min(low, limit));
          high = Math.max(0, Math.min(high, limit));
          if (low > high) { if (index === 0) low = high; else high = low; }
          ranges[0].value = String(low);
          ranges[1].value = String(high);
          if (source && source !== 'input') { fields[0].value = String(low); fields[1].value = String(high); }
          fields[0].max = String(high);
          fields[1].min = String(low);
          ranges[0].setAttribute('aria-valuemax', String(high));
          ranges[1].setAttribute('aria-valuemin', String(low));
          track.style.setProperty('--low', `${limit ? low / limit * 100 : 0}%`);
          track.style.setProperty('--high', `${limit ? high / limit * 100 : 100}%`);
          ranges[0].style.zIndex = low > limit * .5 ? '2' : '1';
        };
        ranges.forEach((input, index) => input.addEventListener('input', () => sync('range', index)));
        fields.forEach((input, index) => {
          input.addEventListener('input', () => sync('input', index));
          input.addEventListener('change', () => sync('field', index));
        });
        this.closest('form')?.addEventListener('formdata', event => {
          if (Number(fields[0].value || 0) === 0) event.formData.delete(fields[0].name);
          if (Number(fields[1].value || limit) === limit) event.formData.delete(fields[1].name);
        });
        sync();
      }
    });
  }
  const appStyles = `
    .gw-btn { border-radius:999px!important; }
    .gw-btn--mode-primary { background:#30833b!important;border-color:#30833b!important;color:#fff!important; }
    .gw-btn--mode-secondary { border-color:#30833b!important;color:#30833b!important; }
    .gw-rv-avg-rating,.gw-rv-avg-rating__star,.gw-rv-rating-stars,.gw-rv-rating-stars__star { color:#d7a51c!important; }
    .gw-rv-rate-stars__star { color:#d7a51c!important; }
    .gw-rv-rate-stars__star:not(.gw-rv-rate-stars__star--active) svg path { fill:none!important;stroke:#d7a51c!important;stroke-width:1; }
    [style*="--gw-rv-"] { --gw-rv-icon-starColor:#d7a51c!important; }
    [style*="--gw-wl-"] { --gw-wl-wishlistIconSettings-heartColor:#30833b!important;--gw-wl-wishlistThemeSettings-primaryColor:#30833b!important;--gw-wl-wishlistThemeSettings-secondaryColor:#30833b!important; }
    .gw-wl-icon { color:#30833b!important; }
    [style*="--gw-wl-"] { --gw-wl-theme-primaryColor:#30833b!important;--gw-wl-theme-secondaryColor:#30833b!important;--gw-wl-icon-heartColor:#30833b!important;--gw-wl-add-to-button-highlightColor:#23672c!important;--gw-wl-drawer-launcherFontColor:#30833b!important;--gw-wl-drawer-linkColor:#30833b!important; }
    .gw-toggle-wishlist-product-card-button__counter { display:none!important; }
    .gw-toggle-wishlist-product-card-button { color:#30833b!important; }
  `;
  const brandedRoots = new WeakSet();
  const styleAppTree = (tree, insideApp = false, rescan = false) => {
    const selector = insideApp ? '*' : '[class*="gw-"],[id^="gw-"]';
    const candidates = tree.nodeType === 1 ? [tree, ...tree.querySelectorAll(selector)] : [...tree.querySelectorAll(selector)];
    candidates.forEach(element => {
      if (!element.shadowRoot || (!insideApp && !element.closest('[class*="gw-"],[id^="gw-"]'))) return;
      const root = element.shadowRoot;
      if (!brandedRoots.has(root)) {
        brandedRoots.add(root);
        const style = document.createElement('style');
        style.textContent = appStyles;
        root.append(style);
        new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
          if (node.nodeType === 1) styleAppTree(node, true);
        }))).observe(root, {childList:true,subtree:true});
        styleAppTree(root, true, rescan);
      } else if (rescan) {
        // An existing child can attach a shadow root without a DOM mutation.
        styleAppTree(root, true, true);
      }
    });
  };
  const setupAppStyles = () => {
    styleAppTree(document);
    const pending = new Set();
    let scheduled = false;
    const flush = () => {
      scheduled = false;
      const roots = [...pending];
      pending.clear();
      roots.forEach(node => {
        if (node.isConnected && !roots.some(parent => parent !== node && parent.contains(node))) styleAppTree(node);
      });
    };
    new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(node => {
        if (node.nodeType === 1 && !node.matches('style,script,link,svg,path')) pending.add(node);
      }));
      if (pending.size && !scheduled) {
        scheduled = true;
        requestAnimationFrame(flush);
      }
    }).observe(document.body, {childList:true,subtree:true});
    document.addEventListener('click', event => {
      if (event.target.closest('[data-ffg-wishlist],.header__icon--wishlist,[class*="gw-"]')) {
        setTimeout(() => styleAppTree(document, false, true), 300);
      }
    }, {passive:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupAppStyles, {once:true});
  else setupAppStyles();
  const reviewHashes = new Set(['#ff-product-reviews', '#judgeme_product_reviews', '#shopify-product-reviews', '#halo-product-review']);
  const reviewTarget = () => document.getElementById('judgeme_product_reviews') || document.getElementById('ff-product-reviews');
  const scrollReviews = () => {
    const target = reviewTarget();
    if (!target) return false;
    target.setAttribute('tabindex', '-1');
    target.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
    target.focus({preventScroll:true});
    return target.getBoundingClientRect().height > 50;
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('a.ffp-review');
    if (!link) return;
    const url = new URL(link.href, location.href);
    if (url.pathname !== location.pathname || !reviewHashes.has(url.hash)) return;
    if (!reviewTarget()) return;
    event.preventDefault();
    event.stopPropagation();
    history.replaceState(null, '', '#ff-product-reviews');
    scrollReviews();
  }, true);
  const onHash = () => { if (reviewHashes.has(location.hash)) scrollReviews(); };
  window.addEventListener('hashchange', onHash);
  if (reviewHashes.has(location.hash)) {
    if (!scrollReviews()) {
      const observer = new MutationObserver(() => {
        if (reviewTarget()?.getBoundingClientRect().height > 50) { observer.disconnect(); scrollReviews(); }
      });
      observer.observe(document.getElementById('MainContent') || document.body, {childList:true,subtree:true});
      setTimeout(() => observer.disconnect(), 15000);
    }
  }
})();

